import { IntlFormatters, MessageDescriptor } from 'react-intl';
import { UserCategoryEnum } from '../../apiRtk/be4feApi';
import messages from './messages';

export enum UserCategories {
  DISTRIBUTOR = 'DISTRIBUTOR',
  HOME_OWNER = 'HOME_OWNER',
  IT = 'IT',
  OTHER = 'OTHER',
  PROPERTY_OR_FACILITY_MANAGER = 'PROPERTY_OR_FACILITY_MANAGER',
  SECURITY_MANAGER = 'SECURITY_MANAGER',
  SERVICES = 'SERVICES',
  SYSTEM_INTEGRATOR = 'SYSTEM_INTEGRATOR',
}

const userCategoryOptionsMap: { [key: string]: MessageDescriptor } = {
  [UserCategories.DISTRIBUTOR]: messages.userCategoryMenuItemDistributor,
  [UserCategories.HOME_OWNER]: messages.userCategoryMenuItemHomeOwner,
  [UserCategories.IT]: messages.userCategoryMenuItemIT,
  [UserCategories.OTHER]: messages.userCategoryMenuItemOther,
  [UserCategories.PROPERTY_OR_FACILITY_MANAGER]: messages.userCategoryMenuItemPropertyManager,
  [UserCategories.SECURITY_MANAGER]: messages.userCategoryMenuItemSecurity,
  [UserCategories.SERVICES]: messages.userCategoryMenuItemServices,
  [UserCategories.SYSTEM_INTEGRATOR]: messages.userCategoryMenuItemSystemIntegrator,
};

export function getUserCategoryOptions(
  formatMessage: IntlFormatters['formatMessage']
): { label: string; value: UserCategoryEnum }[] {
  return [
    {
      label: formatMessage(userCategoryOptionsMap[UserCategories.PROPERTY_OR_FACILITY_MANAGER]),
      value: UserCategories.PROPERTY_OR_FACILITY_MANAGER,
    },
    {
      label: formatMessage(userCategoryOptionsMap[UserCategories.SECURITY_MANAGER]),
      value: UserCategories.SECURITY_MANAGER,
    },
    { label: formatMessage(userCategoryOptionsMap[UserCategories.SERVICES]), value: UserCategories.SERVICES },
    { label: formatMessage(userCategoryOptionsMap[UserCategories.HOME_OWNER]), value: UserCategories.HOME_OWNER },
    {
      label: formatMessage(userCategoryOptionsMap[UserCategories.SYSTEM_INTEGRATOR]),
      value: UserCategories.SYSTEM_INTEGRATOR,
    },
    { label: formatMessage(userCategoryOptionsMap[UserCategories.DISTRIBUTOR]), value: UserCategories.DISTRIBUTOR },
    { label: formatMessage(userCategoryOptionsMap[UserCategories.IT]), value: UserCategories.IT },
    { label: formatMessage(userCategoryOptionsMap[UserCategories.OTHER]), value: UserCategories.OTHER },
  ];
}
